import { memo } from 'react';
import { DialogAlertContent, DialogButton } from '~/components/ui/LegacyDialog';
import type { DialogContent } from '~/lib/stores/menu';

export const FatalErrorDialogContent = memo(({ error, variant }: Extract<DialogContent, { type: 'fatal-error' }>) => {
  return (
    <DialogAlertContent
      icon="error"
      title={
        variant === 'out-of-memory'
          ? 'Memory limit reached'
          : variant === 'webcontainer-startup-timeout'
            ? error.message
            : 'WebContainer startup error'
      }
      description={
        variant === 'out-of-memory' ? (
          <>
            The browser tab has reached its memory limit. This can happen when working with large files, too many
            dependencies, running memory-intensive tasks, or during long sessions.
            <br />
            <br /> Please save your work and reload the page to continue using Bolt.
          </>
        ) : (
          'This may be caused by browser extensions or browser settings. If it persists, please report the issue. You can also try using another browser or Chrome guest mode to see if it works.'
        )
      }
      actions={
        <>
          <DialogButton variant="secondary" onClick={() => location.reload()}>
            Reload the page
          </DialogButton>

          <DialogButton asChild variant="secondary">
            <a
              href={
                variant === 'out-of-memory'
                  ? 'https://bolt.fyi/out-of-memory'
                  : 'https://bolt.fyi/webcontainer-startup-error'
              }
              target="_blank"
            >
              Learn more about {variant === 'out-of-memory' ? 'memory optimization' : 'startup errors'}
            </a>
          </DialogButton>
        </>
      }
    />
  );
});
